import React from "react";
import { IRequiredMultiModifier } from "../../../models/try2Combo";
import { Row, Col } from "react-bootstrap";
import CounterCard from "../../../components/Molecules/Card/CounterCard/CounterCard";
import * as Constants from "../../../constants";
import { isItSubstituteGroupFromMultipleRequired, verifyStatus } from "../../../helpers/customizedItem/customizedItem.helper";
import SelectCard from "../../../components/Molecules/Card/SelectCard/SelectCard";
import styleClasses from "../../../components/Molecules/Card/CounterCard/counterCard.module.scss";
import buttonStyleClasses from "../../../containers/try2/try2.module.scss";
import { Scrollbars } from "react-custom-scrollbars-2";
import { REQUIRED_MODIFIERS } from "../../../constants";
import { itemBuckets } from "../../../priceCalculation/buckets";
import { IRequiredModifiersGroupsModifiers } from "../../../models/item.model";
import RecommendedButton from "../../../containers/try2/Customization/categoriesSelection/Buttons/RecommendedButton";
import ApplyButton from "../../../containers/try2/Customization/try2Customization/ApplyButton";
import NoDressing from "../../../containers/try2/Customization/try2Customization/cards/NoDressing";


const OtherDressingChild: React.FC<IRequiredMultiModifier> = (props) => {
  const {
    setOtherDressingData,
    requiredModifierGroup,
    selectedIngredients,
    handleIngredientSelection,
    noDressingHandler,
    selectedAddedIngredients,
    isNoDressing,
    sectionSelected,
    showRecommendedButton = true,
    addSelectedIngredients,
    selectedOtherDressingData,
    label,
    enableOtherRequiredByDefaultSelectionAndSizeClickAction,
    price,
  } = props;
  let selectedIngredientsFromGroup = selectedIngredients?.filter(selected => selected.modifier_group_id === requiredModifierGroup.id)
  const handleClick = (data, in_item, in_slide) => {
    handleIngredientSelection({
      ...data,
      ...{
        modifier_group_id: requiredModifierGroup.id,
        modifier_group_max: requiredModifierGroup.max,
        modifier_group_base: requiredModifierGroup.base,
        brink_modifier_group_id:
          requiredModifierGroup.brink_modifier_group_id,
        in_item,
        modifier_type: Constants.REQUIRED_MODIFIERS,
        in_slide,
      },
    });
  };

  const showModifier = (modifier, selected) => {
    if (!modifier?.in_item || selected?.in_slide || modifier?.in_item) {
      return true;
    }
    return false;
  };

  const isLimitExceed = (extendable_limit:number) => {
    if(extendable_limit === 1){
      return false
    }
    const isNoDressingExist = selectedAddedIngredients.find((mod:any) => mod.modifier_name === Constants.NO_DRESSING_CAPITALIZE);
    if(isNoDressingExist){
      extendable_limit += 1
    }
    if(selectedAddedIngredients.length >= extendable_limit){
      return true
    }else{
      return false
    }
  };

  const selectedIngredient = (modifier) => {
    return selectedIngredients.find(
      (selected) =>
        selected.modifier_id === modifier.id && !selected.core
    );
  }


  const noDressing = (function () {
    const requiredModifiersBucket = itemBuckets.getSingleBucket({name:REQUIRED_MODIFIERS,fromItem:parseInt(sectionSelected)});
    if(requiredModifiersBucket?.noDressings){
      const noDressingState = requiredModifiersBucket?.noDressings.find(e => e.id === requiredModifierGroup?.id)
      return noDressingState && noDressingState.noDressing
    }else{
      return false
    }
  })();
  
  const name = label ?? 'Modifiers';

  const decideCard = (modifier: IRequiredModifiersGroupsModifiers) => {
    let isCategorySelected = selectedIngredients.find(
      selected => selected.modifier_group_id === requiredModifierGroup.id
    )
    return isCategorySelected
      && !isItSubstituteGroupFromMultipleRequired(requiredModifierGroup) && modifier?.max > 1
  }

  return (
    <>
    <div
      className={`${styleClasses.try2_all_dressing} other-dressing-view try2_dressing_modal`}
    >
      <RecommendedButton 
        showRecommendedButton={showRecommendedButton}
        handleClick={setOtherDressingData}
        text={label}
      />
      <h5 className="text-center text-md-start f-s22 f-sm-s16 text-sm-uppercase mb-md-2 mb-0 ls-sm-normal font-sm-Cls" data-testid="item-otherChild">
        Other {name}
      </h5>
      <hr className="mb-4 mt-2 mt-md-3 d-md-none" />
      <Scrollbars className="Modal_inner_scrollbar">
      {requiredModifierGroup && (
        <Row className="mb-4 mb-md-5 mx-0">
          {requiredModifierGroup?.required_modifiers_groups_modifiers?.map((modifier) => {
            const selected = selectedIngredient(modifier)
            return (
              showModifier(modifier, selected) && (
                <Col xs="4" sm="3" className="py-md-3">
                  {decideCard(modifier) ? (
                    <CounterCard
                      id={modifier?.id}
                      brink_id={modifier?.brink_modifier_id}
                      image={`${Constants.REACT_APP_CLOUD_FRONT}${modifier?.image}`}
                      title={modifier.name}
                      price={modifier.price}
                      calories={modifier.calories}
                      max={modifier.max}
                      is_active={verifyStatus(
                        modifier,
                        Constants.MODIFIER_LOCATION
                      )}
                      handleClick={(data) => {
                        handleClick(data, modifier?.in_item, true);
                      }}
                      priceAlternateLabel={
                        selected ? ' ' : ' '
                      }
                      groupMin={requiredModifierGroup.min}
                      count={selected?.quantity || 0}
                      from={Constants.TRY_2_COMBO}
                      additionalPrice={selected?.additionalPrice}
                      extendableLimit={isLimitExceed(requiredModifierGroup.extendable_limit)}
                      extendableLimitValue={requiredModifierGroup.extendable_limit}
                    />
                  ) : (
                    <SelectCard
                      id={modifier?.id}
                      brink_id={modifier?.brink_modifier_id}
                      image={`${Constants.REACT_APP_CLOUD_FRONT}${modifier?.image}`}
                      title={modifier.name}
                      price={modifier.price}
                      calories={modifier.calories}
                      is_active={verifyStatus(
                        modifier,
                        Constants.MODIFIER_LOCATION
                      )}
                      priceAlternateLabel={
                        selected ? ' ' : ' '
                      }
                      handleClick={(data) => {
                        handleClick(data, modifier?.in_item, true);
                      }}
                      groupMin={requiredModifierGroup.min}
                      selected={Boolean(selected)}
                      default_selected={modifier.is_selected}
                      modifierAdditionalPrice={selected?.additionalPrice}
                      extendableLimit={isLimitExceed(requiredModifierGroup.extendable_limit)}
                      extendableLimitValue={requiredModifierGroup.extendable_limit}
                    />
                  )}
                </Col>
              )
            );
          })}
          {requiredModifierGroup.min === 0 && (
            <Col xs="4" sm="3" className="py-md-3">
              <NoDressing 
                label={requiredModifierGroup.label}
                groupId={requiredModifierGroup.id}
                noDressingHandler={noDressingHandler} 
                isNoDressing={noDressing}
                itemNo={sectionSelected}
                />
              </Col>
            )}
          </Row>
        )}
      </Scrollbars>

      <hr className="d-md-none" />
    </div>

    <ApplyButton
        isDisabled={!(selectedIngredientsFromGroup.length > 0) && selectedIngredientsFromGroup.length <= requiredModifierGroup?.min && !noDressing}
      selectedOtherDressingData={selectedOtherDressingData}
      clickHandle={() => addSelectedIngredients(true)} 
      btnClass={buttonStyleClasses.large_btn}
      label={enableOtherRequiredByDefaultSelectionAndSizeClickAction ? Constants.ADD_TO_ORDER : Constants.APPLY}
      price={price}
    />
</>
  );
};

export default OtherDressingChild;

